import { adColumnPreviewStyle } from './ad-column-preview-style';
import {
  alertStyle,
  btnStyle,
  buttonInputStyle,
  paginationStyle,
} from './shared-styles-from-theme-fluent';
import { convertToLocalStyle } from './utils/convert-style';
import { getReactModalStyle } from './react-modal-style';
import { glyphIconStyle } from './glyph-icon-style';
import { tableStyle } from './table-style';

export const adSuggestionStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .ad-suggestion-container': {
    padding: '12px 32px',
    borderBottom: [1, 'solid', palette.neutralLight],
    marginBottom: 0,

    '& .table-container': {
      fontSize: 13,
      lineHeight: '19px',

      '& table > thead > tr > th, table > tbody > tr > td': {
        padding: '8px 10px',
        verticalAlign: 'middle',
      },
      '& table > colgroup + thead > tr:first-child > th': {
        borderTop: '0 !important',
      },
      '& table > thead > tr > th.text-center': {
        textAlign: 'center',
      },
      '& table > tfoot > tr > td': {
        border: 0,
      },
      '& col.col-selection': {
        width: 50,
        minWidth: 50,
      },
      '& col.col-RecommendedAd': {
        width: 350,
        minWidth: 350,
      },
      '& col.col-Campaign': {
        width: 250,
        minWidth: 250,
      },
      '& col.col-AdGroup': {
        width: 250,
        minWidth: 250,
      },
      '& col.col-ApplyDate': {
        width: 100,
        minWidth: 100,
      },
      '& col.col-Dismiss': {
        width: 50,
        minWidth: 50,
      },
      '& tbody > tr .grid-edit-icon': {
        lineHeight: 1,
        visibility: 'visible',
        opacity: 0,

        '&:focus': {
          visibility: 'visible',
          opacity: 100,
        },
      },
      '& tbody > tr:hover': {
        backgroundColor: palette.neutralLighter,

        '& .grid-edit-icon': {
          visibility: 'visible',
          opacity: 100,
        },
      },
      '& .grid-editable-cell-container': {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-start',

        '& .previewAd': {
          lineHeight: 1.5,

          '& a.previewTitleAd': {
            lineHeight: 1,
          },

          '& img': {
            marginRight: 8,
          },
        },
      },
      '& .dismiss-recommendation': {
        cursor: 'pointer',
      },
      '& a.select-all-cross-page, a.deselect-all-cross-page': {
        marginLeft: 5,
      },
      '& input[type="checkbox"]:focus': {
        outline: `1px solid ${palette.neutralSecondary} !important`,
        outlineOffset: 1,
      },
    },
    '& .btn-primary': {
      marginRight: 10,
    },
    '& .alert.alert-recommendation': {
      background: palette.themeLighterAlt,
      border: [1, 'solid', palette.themePrimary],
      padding: '10px 32px 10px 8px',
      lineHeight: '16px',

      '& .alert-info-inline': {
        width: '100%',
      },

      '& .glyphicon, .recommendation-light-bulb': {
        color: palette.themePrimary,
        fontSize: 16,
        lineHeight: '22px',
        verticalAlign: 'middle',
      },

      '& .recommendation-light-bulb': {
        margin: '0 5px 0 8px',
      },

      '& .recommendation-detail-info': {
        fontWeight: 600,
        '& a': {
          color: palette.themeDark,
        },
      },
    },
    '& .ad-suggestion-panel': {
      '& #ad-suggestion-dropdown': {
        width: 'fit-content',
      },
      '& .previewAd': {
        '& img': {
          marginRight: 5,
        },
      },
    },
    '& .value-proposition': {
      paddingTop: 16,
      paddingBottom: 10,
    },
    '& .disabled': {
      'pointer-events': 'none',
    },
    ...adColumnPreviewStyle(),
    ...alertStyle({ palette }),
    ...buttonInputStyle({ palette }),
    ...paginationStyle({ palette }),
    ...tableStyle({ palette }),
    ...convertToLocalStyle(glyphIconStyle({ palette, iconFontFamily })),
  },
});

export const adSuggestionModalStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '.adsbybing-optin-modal': {
    maxWidth: 940,

    '& .adsbybing-optin-modal-info': {
      '& br': {
        display: 'none',
      },
      '& .adsbybing-optin-modal-title': {
        fontWeight: 600,
        fontSize: 20,
        marginBottom: 8,
      },
    },
    '& .adsbybing-optin-dismiss-feedback': {
      marginTop: 16,
    },
    '& .adsbybing-optin-action-container, .actions': {
      marginTop: 16,

      '& .btn': {
        marginRight: 8,
      },
    },
    '& .closeimage': {
      color: palette.neutralSecondary,
      fontFamily: iconFontFamily,
      fontSize: 12,

      '&:before': {
        content: '"\\E711"',
      },
    },
    ...buttonInputStyle({ palette }),
    ...convertToLocalStyle(btnStyle({ palette })),
  },
  ...getReactModalStyle(),
});
